export default "__VITE_ASSET__DccFwhxL__"